import { useFormikContext } from 'formik';
import ApplicationFee from 'src/ui-component/ApplicationFee';

type PetApplicationFeeWithFormikProps = {
  setTaxRate: (rate: number) => void;
  setFeeDetails: (details: any) => void;
  feeDetails: any;
  isSpayedNeutered?: unknown;
};

export default function PetApplicationFeeWithFormik ({
  setTaxRate,
  setFeeDetails,
  feeDetails,
  isSpayedNeutered
}: PetApplicationFeeWithFormikProps) {
  const { values } = useFormikContext<{
    ApplicationDate?: string;
    LateFeesWaived?: unknown;
  }>();
  return (
    <ApplicationFee
      setTaxRate={setTaxRate}
      setFeeDetails={setFeeDetails}
      feeDetails={feeDetails}
      isSpayedNeutered={isSpayedNeutered}
      petFeeFormContext={{
        applicationDate: values.ApplicationDate,
        lateFeesWaived: values.LateFeesWaived
      }}
    />
  );
}
